var map = {
	"./bean.svg": "cde2",
	"./bean_black.svg": "5ca3",
	"./bean_img.png": "3f50",
	"./bubble.png": "5740",
	"./bubble.svg": "1b71",
	"./content_icons/anotation.svg": "db67",
	"./content_icons/audio_record.svg": "9e45",
	"./content_icons/interactive_tasks.svg": "c4f8",
	"./content_icons/library.svg": "f58a",
	"./content_icons/math.svg": "b4d2",
	"./content_icons/media_embed.svg": "35cc",
	"./content_icons/social_media_embed.svg": "d401",
	"./content_icons/survey.svg": "ba11",
	"./content_icons/test_types.svg": "cac5",
	"./content_icons/url_embed.svg": "cf99",
	"./content_icons/user_upload_task.svg": "cdc6",
	"./content_icons/website_upload.svg": "13ad",
	"./content_icons/whiteboard.svg": "cbf8",
	"./content_icons/writting_task.svg": "fb3e",
	"./lock.svg": "3c1a",
	"./logo.png": "cf05",
	"./scss/_button.scss": "7c08",
	"./scss/_inputs.scss": "ca23",
	"./scss/_layout.scss": "9ab3",
	"./social_icons/explore.svg": "8ea0",
	"./social_icons/facebook.svg": "a98c",
	"./social_icons/instagram.svg": "267d",
	"./social_icons/learning_apps.svg": "33d8",
	"./social_icons/mobile/explore.svg": "ae50",
	"./social_icons/mobile/facebook.svg": "8a98",
	"./social_icons/mobile/instagram.svg": "f4b7",
	"./social_icons/mobile/learning_apps.svg": "7b9f",
	"./social_icons/mobile/ms_teams.svg": "718f",
	"./social_icons/mobile/soundcloud.svg": "80e7",
	"./social_icons/mobile/spotify.svg": "79c2",
	"./social_icons/mobile/tiktok.svg": "73ce",
	"./social_icons/mobile/twitter.svg": "3e46",
	"./social_icons/mobile/vimeo.svg": "12c3",
	"./social_icons/mobile/wordwall.svg": "ebff",
	"./social_icons/mobile/youtube.svg": "2f18",
	"./social_icons/mobile/zoom.svg": "f10d",
	"./social_icons/ms_teams.svg": "241cf",
	"./social_icons/soundcloud.svg": "9db9",
	"./social_icons/spotify.svg": "12cf",
	"./social_icons/tiktok.svg": "797c",
	"./social_icons/twitter.svg": "6397",
	"./social_icons/vimeo.svg": "329b",
	"./social_icons/wordwall.svg": "b9ca",
	"./social_icons/youtube.svg": "ca97",
	"./social_icons/zoom.svg": "936f",
	"./use_icons/control_authenticity.svg": "2fb0",
	"./use_icons/creative_book.svg": "a042",
	"./use_icons/idea.svg": "7757",
	"./use_icons/location.svg": "f7a8",
	"./use_icons/magic_touch.svg": "eecb",
	"./use_icons/magical_brainstorm.svg": "3fe9",
	"./use_icons/map.svg": "5107",
	"./use_icons/observe.svg": "d41d",
	"./use_icons/pencil.svg": "b9bc",
	"./use_icons/reusability.svg": "824b",
	"./use_icons/structured_books.svg": "8788",
	"./use_icons/unlimited_paper.svg": "0df2"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";